import styled from 'styled-components'

export const Container = styled.div`
  background-color: #f7fafe;
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
  margin-bottom: 1rem;
`
